import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { User } from '../users.component';
import { Subscription, debounceTime } from 'rxjs';
import { FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-users-filter-form',
  templateUrl: './users-filter-form.component.html',
  styleUrl: './users-filter-form.component.scss'
})
export class UsersFilterFormComponent implements OnInit, OnDestroy, OnChanges{
  @Input() usersList: User[] = [];
  @Input() initialTitle: string = '';

  @Output() filterClicked = new EventEmitter<string>();
  @Output() inputChanged = new EventEmitter<string>();

  private readonly debounceTime = 250;
  private componentIntialized = false;
  private subscriptions = new Subscription();
  private title: string = '';
  private input: UntypedFormControl;

  public formGroup: FormGroup;

  constructor(

  ) {}

  ngOnInit(): void {
    this.input = new UntypedFormControl(this.initialTitle);

    this.initializeFilterForm();
    this.componentIntialized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!this.componentIntialized) {
      return;
    }

    if(changes.initialTitle && !changes.initialTitle.firstChange) {
      this.input.setValue(this.initialTitle);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onFilterFormSubmit() {
    this.title = this.formGroup.value.title;
    this.filterClicked.emit(this.title);
  }

  private initializeFilterForm() {
    this.formGroup = new UntypedFormGroup({
      title: this.input,
    });

    this.subscriptions.add(
      this.input.valueChanges.pipe(debounceTime(this.debounceTime)).subscribe((value) => {
        this.inputChanged.emit(value);
      })
    );
  }
}
